module.exports = __webpack_public_path__ + "static/media/teaser.1c42b8e0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Videos/medias/teaser.mp4
// module id = 210
// module chunks = 0